import {Injectable} from "@angular/core";
import {Controller} from "../../interface/controller.interface";
import {HTTPService} from "../http.service";
import {EnvironmentService} from "../environment.service";
import {QueryParamsModel, QueryResultsModel} from "../../core/_base/crud";
import {Observable} from "rxjs";
import {HTTPRequestBuilder} from "../../model/http.request.model";
import {HTTPMethod} from "../../model/http-method.enum";
import {SaveCatalogProductDto, SaveProductDto} from "../../model/club-gigot/catalog/save-catalog-product.dto";
import { CategoryProductDTO } from "../../model/club-gigot/inventory-points/product-category/category-product.dto";
import { ClaimedProductDto } from "../../model/club-gigot/user-points/claimed-product.dto";


/**
 * @description
 *  Servicio reflejo del controlador Rewards.
 */
@Injectable({ providedIn: "root" })
export class CatalogService implements Controller {

    constructor(private httpService: HTTPService, private environmentService: EnvironmentService) {}

    hostPath(): string {
        return this.environmentService.rewardsBackendHost.href;
    }
    public basePath(): string {
        return "api/rewards";
    }

    public getCatalogProducts(queryParams: QueryParamsModel, campaignSequence: number): Observable<QueryResultsModel> {
        return this.httpService.send<QueryParamsModel, QueryResultsModel>(
            new HTTPRequestBuilder<QueryParamsModel>()
                .method(HTTPMethod.POST)
                .host(this.hostPath())
                .controllerPath(this.basePath())
                .relativePath(`catalog/${campaignSequence}`)
                .payload(queryParams)
                .build()
        )
    }

    public saveCatalogProducts(products: SaveCatalogProductDto, campaignSequence: number): Observable<void>{
        return this.httpService.send<SaveProductDto[],null>(
            new HTTPRequestBuilder<SaveProductDto[]>()
                .method(HTTPMethod.PATCH)
                .host(this.hostPath())
                .controllerPath(this.basePath())
                .relativePath(`catalog/${campaignSequence}`)
                .payload(products.products)
                .build()
        )
    }

    public getCatalogCategories(campaignSequence : number) : Observable<CategoryProductDTO[]>{
        return this.httpService.send<typeof undefined,CategoryProductDTO[]>(
            new HTTPRequestBuilder<typeof undefined>()
                .method(HTTPMethod.GET)
                .host(this.hostPath())
                .controllerPath(this.basePath())
                .relativePath(`catalog/${campaignSequence}/categories`)
                .build()
        )
    }

    public saveCatalogCategory(campaignSequence : number, info : CategoryProductDTO) : Observable<void> {
        return this.httpService.send<CategoryProductDTO, null>( 
            new HTTPRequestBuilder<CategoryProductDTO>() 
                .method(info.id ? HTTPMethod.PATCH : HTTPMethod.POST) 
                .host(this.hostPath()) 
                .controllerPath(this.basePath()) 
                .relativePath(`catalog/${campaignSequence}/category`) 
                .payload(info) 
                .build()); 
    }

    public deleteCategory(campaignSequence : number, categoryId : number) : Observable<void> {
        return this.httpService.send<typeof undefined, null>( 
            new HTTPRequestBuilder<typeof undefined>() 
                .method(HTTPMethod.DELETE) 
                .host(this.hostPath()) 
                .controllerPath(this.basePath()) 
                .relativePath(`catalog/${campaignSequence}/category/${categoryId}`) 
                .build()); 
    }

    public getApplicableClaimedRewards(userName : string, campaignSequence : number) : Observable<ClaimedProductDto[]>{
        return this.httpService.send<typeof undefined, ClaimedProductDto[]>(
            new HTTPRequestBuilder<typeof undefined>()
                .method(HTTPMethod.GET)
                .host(this.hostPath())
                .controllerPath(this.basePath()) 
                .relativePath(`claimed/${campaignSequence}/${userName}`) 
                .build()
        )
    }

    public checkClaimedRewards(campaignProductId: number) : Observable<ClaimedProductDto[]>{
        return this.httpService.send<typeof undefined, ClaimedProductDto[]>(
            new HTTPRequestBuilder<typeof undefined>()
                .method(HTTPMethod.GET)
                .host(this.hostPath())
                .controllerPath(this.basePath()) 
                .relativePath(`claimed/${campaignProductId}`) 
                .build()
        )
    }   

    public returnClaimedRewardById(userName : string, currentCampaingSequence : number, claimedRewardId : number):Observable<void>{
        return this.httpService.send<typeof undefined, void>(
            new HTTPRequestBuilder<typeof undefined>()
                .host(this.hostPath())
                .controllerPath(this.basePath())
                .relativePath(`claimed/returnbyid/${userName}/${currentCampaingSequence}/${claimedRewardId}`)
                .method(HTTPMethod.PATCH)
                .build()
        )
    }
}
